import { render, staticRenderFns } from "./ITNotAssetsScrap.vue?vue&type=template&id=4bda2dd7&scoped=true"
import script from "./ITNotAssetsScrap.vue?vue&type=script&lang=js"
export * from "./ITNotAssetsScrap.vue?vue&type=script&lang=js"
import style0 from "./ITNotAssetsScrap.vue?vue&type=style&index=0&id=4bda2dd7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bda2dd7",
  null
  
)

export default component.exports